var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',{attrs:{"notice":_vm.$t('auth.resetPassWord'),"headerLeftStatus":'leftArrow'}},[_c('div',[_c('Account',{on:{"callback":_vm.accountCallack}}),_c('div',{staticClass:"btn-box margin-top20"},[_c('van-button',{attrs:{"type":"info","disabled":_vm.resetDisabled},on:{"click":_vm.checkAccount}},[_vm._v(_vm._s(_vm.$t('next')))])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }